import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';

@Component({
	selector: 'app-edms-cart',
	templateUrl: './edms-cart.component.html',
	styleUrls: ['./edms-cart.component.css']
})
export class EdmsCartComponent implements OnInit {
	@ViewChild(MatSelectionList) matSelectionList!: MatSelectionList;
	@Input() allItems!: any[];
	// @Input() selectedItems: any[] = [];
	@Input() key: any;
	@Input() textField: any;
	selectedItems = ['text', 'text'];
	ngOnInit() {
	}

	drop(event: CdkDragDrop<any[]>) {
		moveItemInArray(this.selectedItems, event.previousIndex, event.currentIndex);
	}

	addItems() {
		this.matSelectionList.selectedOptions.selected.forEach(x => this.selectedItems.push(x.value));
	}
}
